import { writable, get } from 'svelte/store'
import { observable } from '@/meteor.js'

export const currentOrder = createCurrentOrderStore()



function createCurrentOrderStore() {
    const { subscribe, set, update } = writable(false)
    let currentOrderId = localStorage.getItem('currentOrderId')
    let unsubscribeObservableOrderStore

    function resubscribe() {
        if (unsubscribeObservableOrderStore) unsubscribeObservableOrderStore()
        console.log('subbing in currentOrder')
        const ObservableOrderStore = observable('orders', currentOrderId)
        unsubscribeObservableOrderStore = ObservableOrderStore.subscribe(value => {
            console.log('setting', value)
            set(value)
        })
    }


    function _subscribe(...params) {
        const unsub = subscribe(...params)
        resubscribe()
        return unsub
    }


    return {
        subscribe: _subscribe,
        set, update,
        get: () => get(currentOrder),
        selectId(id) {
            currentOrderId = id
            localStorage.setItem('currentOrderId', id)
            resubscribe()
        }
    }
}

